import { useParams } from 'react-router-dom'
import { Col, Row, Space } from 'antd'

interface person {
    check_in_id: string
    belong_minion_id: string//责任管家id
    belong_minion_name: string, // 责任管家名称
    belong_cleaner_id: string, // 生活助理（保洁）id
    belong_cleaner_name: string, // 生活助理（保洁）名称
    belong_nurse_id: string, // 责任护士id
    belong_nurse_name: string, // 责任护士名称
    belong_dietician_id: string, // 营养师id
    belong_dietician_name: string, // 营养师名称
    belong_recover_id: string, // 产康师id
    belong_recover_name: string, // 产康师名称
    belong_look_after_id: string, // 护理师id
    belong_look_after_name: string // 护理师名称
}

interface Prop {
    status: any,
    storeID?: string
    serviceData?: person
    onChange?: () => void
}
export default function (prop: Prop) {

    const param: { id: string } = useParams()

    return (<div className="modules">
        {/* 月嫂中心 -> 会所客户管理 -> 客户详情 -> 服务人员信息 */}
        <div className="top clear">
            <h3 className="fl"><span className="fl">服务人员信息</span></h3>
        </div>

        <div className="content" style={{ marginTop: 15 }}>
            <Row style={{ width: '100%' }}>
                <Col span={7}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 90, textAlign: 'right' }}>责任管家：</p>
                            <p className='right-text' style={{ width: '230px' }}>{prop.serviceData && prop.serviceData.belong_minion_name ? prop.serviceData.belong_minion_name : '--'} </p>
                        </Space>
                    </div>
                </Col>

                <Col span={7}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 90, textAlign: 'right' }}>生活助理：</p>
                            <p className='right-text' style={{ width: '230px' }}>{prop.serviceData && prop.serviceData.belong_cleaner_name ? prop.serviceData.belong_cleaner_name : '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={7}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 90, textAlign: 'right' }}>责任护士：</p>
                            <p className='right-text' style={{ width: '230px' }}>{prop.serviceData && prop.serviceData.belong_nurse_name ? prop.serviceData.belong_nurse_name : '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>

        <div className="content" style={{ marginTop: 15 }}>
            <Row style={{ width: '100%' }}>
                <Col span={7}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 90, textAlign: 'right' }}>营养师：</p>
                            <p className='right-text' style={{ width: '230px' }}>{prop.serviceData && prop.serviceData.belong_dietician_name ? prop.serviceData.belong_dietician_name : '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={7}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 90, textAlign: 'right' }}>产康师：</p>
                            <p className='right-text' style={{ width: '230px' }}>{prop.serviceData && prop.serviceData.belong_recover_name ? prop.serviceData.belong_recover_name : '--'}</p>
                        </Space>
                    </div>
                </Col>

                <Col span={7}>
                    <div>
                        <Space wrap>
                            <p className="label" style={{ minWidth: 90, textAlign: 'right' }}>护理师：</p>
                            <p className='right-text' style={{ width: '230px' }}>{prop.serviceData && prop.serviceData.belong_look_after_name ? prop.serviceData.belong_look_after_name : '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>
        </div>
    </div>)
}